import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { StationsService } from '@app/shared/services/stations.service';
import { SocietiesService } from '@app/shared/services/societies.service';
import { SessionService } from '@app/shared/services/session.service';
declare var UIkit: any;

@Component({
  selector: 'app-add-station',
  templateUrl: './add-station.component.html',
  styleUrls: ['./add-station.component.scss']
})
export class AddStationComponent implements OnInit {

  public station : any = {
    name: '',
    address: '',
    zipCode: '',
    city: '',
    latitude: "",
    longitude: ""
  };
  public validated : boolean = false;
  public loading : boolean = false;
  public societies : Array<any> = [];
  public selectedSocietyId : number = 0;

  @Output() changed = new EventEmitter();

  constructor(
    private stationService: StationsService,
    private societyService: SocietiesService,
    public session: SessionService
  ) {}

  ngOnInit() {
    if (this.session.role.ability === 'super-admin') {
      this.societyService.getSocieties().then((res) => {
        this.societies = res;
      });
    }
  }

  validator() {
    let result : boolean = true;

    this.validated = false;
    if (this.station.name.length === 0 || this.station.address.length === 0
    || this.station.zipCode.length === 0 || this.station.city.length === 0) {
      result = false;
    }
    if (this.session.role.ability === 'super-admin' && this.selectedSocietyId === 0) {
      result = false;
    }
    this.validated = result;
  }

  resetVariables() {
    this.station = {
      name: '',
      address: '',
      zipCode: '',
      city: '',
      latitude: "",
      longitude: ""
    };
    this.validated = false;
    this.selectedSocietyId = 0;
  }

  submit() {
    this.loading = true;
    this.stationService.addStation({
      ...this.station,
      idSocietyVop: this.selectedSocietyId || this.session.role.id
    }).then(() => {
      this.loading = false;
      this.changed.emit(null);
      this.resetVariables();
      UIkit.modal('#add-station').hide();
    });
  }

}
